import { useSelector } from 'react-redux'

import { ErrorBoundary } from '@webapp/components/ErrorBoundary'
import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ISpendTrackerProps, SpendTracker } from './SpendTracker'
import { type ISheetProps, Sheet } from '../../Sheet'

export interface ISpendTrackerSheetProps extends ISpendTrackerProps {
  isOpen: boolean
  onDismiss: () => void
  container?: ISheetProps['container']
}

export const SpendTrackerSheet = ({
  isOpen = true,
  onDismiss,
  container,
  ...spendTrackerProps
}: ISpendTrackerSheetProps) => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())

  if (!isOpen) return null

  return (
    <Sheet isOpen={isOpen} container={container}>
      <Sheet.Header
        onDismiss={onDismiss}
        iconButtonLabel={intl.formatMessage(
          isFlexibleSpendTrackingEnabled
            ? messages.hideBudgetTrackerButtonLabel
            : messages.hideSpendTrackerButtonLabel
        )}
      >
        {intl.formatMessage(
          isFlexibleSpendTrackingEnabled
            ? messages.budgetTrackerHeader
            : messages.spendTrackerHeader
        )}
      </Sheet.Header>
      <Sheet.Content>
        <ErrorBoundary boundaryName='SpendTrackerSheet'>
          <SpendTracker {...spendTrackerProps} />
        </ErrorBoundary>
      </Sheet.Content>
    </Sheet>
  )
}

SpendTrackerSheet.displayName = 'SpendTrackerSheet'
